module.exports = {
	"v": "4.8.0",
	"meta": {
		"g": "LottieFiles AE 3.4.5",
		"a": "",
		"k": "",
		"d": "",
		"tc": ""
	},
	"fr": 30,
	"ip": 0,
	"op": 60,
	"w": 86,
	"h": 86,
	"nm": "IconTicket_NoLoop_01",
	"ddd": 0,
	"assets": [],
	"layers": [
		{
			"ddd": 0,
			"ind": 1,
			"ty": 4,
			"nm": "Line",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						43,
						43,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-26.453,
											-33.25
										],
										[
											26.375,
											-33.25
										]
									],
									"c": false
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.18431372549,
									0.337254901961,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 3,
								"ix": 5
							},
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Shape 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "tm",
					"s": {
						"a": 0,
						"k": 0,
						"ix": 1
					},
					"e": {
						"a": 1,
						"k": [
							{
								"i": {
									"x": [
										0.667
									],
									"y": [
										1
									]
								},
								"o": {
									"x": [
										0.167
									],
									"y": [
										0.167
									]
								},
								"t": 0,
								"s": [
									0
								]
							},
							{
								"t": 10,
								"s": [
									100
								]
							}
						],
						"ix": 2
					},
					"o": {
						"a": 0,
						"k": 0,
						"ix": 3
					},
					"m": 1,
					"ix": 2,
					"nm": "Trim Paths 1",
					"mn": "ADBE Vector Filter - Trim",
					"hd": false
				}
			],
			"ip": 0,
			"op": 2700,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 2,
			"ty": 1,
			"nm": "Green Solid 4",
			"td": 1,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						43,
						52.75,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						43,
						43,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"sw": 86,
			"sh": 86,
			"sc": "#00ff0a",
			"ip": 0,
			"op": 2700,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 3,
			"ty": 4,
			"nm": "Ticket Shapes",
			"tt": 1,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						43,
						43,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						43,
						43,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											24.23,
											40.579
										],
										[
											61.77,
											40.579
										]
									],
									"c": false
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.188235309077,
									0.341176470588,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 3,
								"ix": 5
							},
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": 0.4,
											"y": 1
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 16,
										"s": [
											0,
											-70
										],
										"to": [
											0,
											0
										],
										"ti": [
											0,
											0
										]
									},
									{
										"t": 36,
										"s": [
											0,
											0
										]
									}
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Line 1",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											24.23,
											49.329
										],
										[
											61.77,
											49.329
										]
									],
									"c": false
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.188235309077,
									0.341176470588,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 3,
								"ix": 5
							},
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": 0.4,
											"y": 1
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 13,
										"s": [
											0,
											-70
										],
										"to": [
											0,
											0
										],
										"ti": [
											0,
											0
										]
									},
									{
										"t": 33,
										"s": [
											0,
											0
										]
									}
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Line 2",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 2,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											24.23,
											58.078
										],
										[
											61.77,
											58.078
										]
									],
									"c": false
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.188235309077,
									0.341176470588,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 3,
								"ix": 5
							},
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": 0.4,
											"y": 1
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 10,
										"s": [
											0,
											-70
										],
										"to": [
											0,
											0
										],
										"ti": [
											0,
											0
										]
									},
									{
										"t": 30,
										"s": [
											0,
											0
										]
									}
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Line 3",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 3,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-0.701,
											-0.729
										],
										[
											0,
											-1.18
										],
										[
											0,
											0
										],
										[
											0.757,
											-0.646
										],
										[
											1.458,
											-0.097
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											1.096,
											0.264
										],
										[
											0,
											0
										],
										[
											-1.888,
											0
										],
										[
											-0.431,
											0.229
										],
										[
											0,
											0.583
										],
										[
											0,
											0
										],
										[
											0.271,
											0.243
										],
										[
											0.5,
											0
										],
										[
											0,
											0
										],
										[
											0.757,
											0.667
										],
										[
											0,
											1.513
										],
										[
											0,
											0
										],
										[
											-0.716,
											0.701
										],
										[
											-1.403,
											0.111
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-1.32,
											-0.278
										],
										[
											0,
											0
										],
										[
											0.972,
											0
										],
										[
											0.403,
											-0.242
										],
										[
											0,
											-0.653
										],
										[
											0,
											0
										],
										[
											-0.298,
											-0.243
										],
										[
											-0.611,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0.701,
											0.729
										],
										[
											0,
											0
										],
										[
											0,
											1.542
										],
										[
											-0.757,
											0.645
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-1.555,
											-0.07
										],
										[
											0,
											0
										],
										[
											1.235,
											0.124
										],
										[
											0.847,
											0
										],
										[
											0.43,
											-0.229
										],
										[
											0,
											0
										],
										[
											0,
											-0.458
										],
										[
											-0.271,
											-0.243
										],
										[
											0,
											0
										],
										[
											-1.528,
											0
										],
										[
											-0.756,
											-0.666
										],
										[
											0,
											0
										],
										[
											0,
											-1.36
										],
										[
											0.715,
											-0.701
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											1.209,
											0.056
										],
										[
											0,
											0
										],
										[
											-1.903,
											-0.124
										],
										[
											-0.792,
											0
										],
										[
											-0.402,
											0.244
										],
										[
											0,
											0
										],
										[
											0,
											0.528
										],
										[
											0.299,
											0.243
										],
										[
											0,
											0
										],
										[
											1.333,
											0
										]
									],
									"v": [
										[
											4.134,
											-0.374
										],
										[
											5.186,
											2.49
										],
										[
											5.186,
											3.363
										],
										[
											4.051,
											6.645
										],
										[
											0.729,
											7.758
										],
										[
											0.729,
											9.507
										],
										[
											-1.02,
											9.507
										],
										[
											-1.02,
											7.758
										],
										[
											-4.998,
											7.258
										],
										[
											-4.998,
											4.822
										],
										[
											-0.313,
											5.01
										],
										[
											1.604,
											4.665
										],
										[
											2.249,
											3.447
										],
										[
											2.249,
											2.885
										],
										[
											1.843,
											1.833
										],
										[
											0.687,
											1.469
										],
										[
											-0.624,
											1.469
										],
										[
											-4.051,
											0.469
										],
										[
											-5.186,
											-2.8
										],
										[
											-5.186,
											-3.55
										],
										[
											-4.113,
											-6.643
										],
										[
											-0.937,
											-7.861
										],
										[
											-1.02,
											-9.007
										],
										[
											0.625,
											-9.507
										],
										[
											0.729,
											-7.882
										],
										[
											0.666,
											-7.861
										],
										[
											4.457,
											-7.361
										],
										[
											4.457,
											-4.925
										],
										[
											0.146,
											-5.113
										],
										[
											-1.646,
											-4.748
										],
										[
											-2.249,
											-3.404
										],
										[
											-2.249,
											-2.988
										],
										[
											-1.802,
											-1.833
										],
										[
											-0.437,
											-1.467
										],
										[
											1.083,
											-1.467
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0,
									0.188235309077,
									0.341176470588,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": 0.4,
											"y": 1
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 19,
										"s": [
											43,
											-45.958
										],
										"to": [
											0,
											0
										],
										"ti": [
											0,
											0
										]
									},
									{
										"t": 39,
										"s": [
											43,
											24.042
										]
									}
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Money",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 4,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-26.376,
											3.848
										],
										[
											-17.499,
											-3.812
										],
										[
											-8.62,
											3.848
										],
										[
											0.188,
											-3.754
										],
										[
											8.688,
											3.581
										],
										[
											17.35,
											-3.895
										],
										[
											26.375,
											3.895
										]
									],
									"c": false
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.188235309077,
									0.341176470588,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 3,
								"ix": 5
							},
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": 0.4,
											"y": 1
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 10,
										"s": [
											43,
											2.531
										],
										"to": [
											0,
											0
										],
										"ti": [
											0,
											0
										]
									},
									{
										"t": 30,
										"s": [
											43,
											72.532
										]
									}
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Ticket Zig Zag",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 5,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-26.376,
											33.321
										],
										[
											-26.376,
											-33.321
										],
										[
											26.375,
											-33.321
										],
										[
											26.375,
											33.321
										]
									],
									"c": false
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.188235309077,
									0.341176470588,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 3,
								"ix": 5
							},
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": 0.4,
											"y": 1
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 10,
										"s": [
											43,
											-27.105
										],
										"to": [
											0,
											0
										],
										"ti": [
											0,
											0
										]
									},
									{
										"t": 30,
										"s": [
											43,
											42.895
										]
									}
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Ticket Outline",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 6,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 2700,
			"st": 0,
			"bm": 0
		}
	],
	"markers": []
};


//////////////////
// WEBPACK FOOTER
// ./frontend/pages/LiveMarkets/animations/howItWorksIcons/IconTicket_NoLoop_01.json
// module id = 651
// module chunks = 0